import { Navigate } from "react-router-dom";

export default function RedirectReviewInbox() {
  return <Navigate to="/dashboard/client/reviews?view=needs-reply" replace />;
}
